import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
Copyright 2024 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { CapabilityPoller } from "./capabilityPoller.js";
import { Method } from "./http-api/index.js";
export var RoomVersionStability = /*#__PURE__*/function (RoomVersionStability) {
  RoomVersionStability["Stable"] = "stable";
  RoomVersionStability["Unstable"] = "unstable";
  return RoomVersionStability;
}({});

/**
 * A representation of the capabilities advertised by a homeserver as defined by
 * [Capabilities negotiation](https://spec.matrix.org/v1.6/client-server-api/#get_matrixclientv3capabilities).
 */

/**
 * Manages storing and periodically refreshing the server capabilities.
 */
export class ServerCapabilities extends CapabilityPoller {
  constructor(logger, http) {
    var _this;
    super(logger, http, "server capabilities");
    _this = this;
    /**
     * Fetches the latest server capabilities from the homeserver and returns them, or rejects
     * on failure.
     */
    _defineProperty(this, "fetch", /*#__PURE__*/_asyncToGenerator(function* () {
      var resp = yield _this.http.authedRequest(Method.Get, "/capabilities");
      _this.cached = resp["capabilities"];
      return _this.cached;
    }));
  }
}
//# sourceMappingURL=serverCapabilities.js.map